import * as React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

import handleMutationError from "app/utils/handleMutationError";
import withStateMutation from "app/utils/withStateMutation";
import { flattenObj } from "app/utils/filters";

import { VerificationLabel, VerificationDialog } from "./Verification";

export enum QueryType {
  // Credit Bureau data with ID Verification. Cost: R4.00
  AddressId = "address_id",
  // Credit Bureau data without ID verification. Cost: R3.00
  AddressCr = "address_cr",
  // South African Photo Identity. Cost: R2.00
  IdPhoto = "id_photo",
  // South African Identity (ID) data (from Home Affairs). Cost: R1.50
  ProfileId = "profile_id",
  // Last 6 known ZA IDs associated with a SA phone number. Cost: R4.50
  ContactToId = "contact_to_id",
  // Company and Directors information from CIPC. Cost: R10.50
  CipcCo = "cipc_co",
  // Company and Directors information from CIPC. Cost: R10.50
  CipcDi = "cipc_di",
  // South African Identity (ID) data (from Home Affairs in realtime). Cost: R4.50
  RealTimeId = "real_time_id",
}

type RecievingProps = {
  children: string;
  queryType: QueryType;
  description: string;
};

type ElementProps = {
  mutate: (opt: any) => any;
  mutateLoading: boolean;
  mutateResult: any;
  mutateError: any;
} & RecievingProps;

type ElementState = {
  verified: boolean;
  modalOpen: boolean;
  verifiedData: { [key: string]: string };
};

class VerificationContainer extends React.Component<
  ElementProps,
  ElementState
> {
  state = {
    verified: false,
    modalOpen: false,
    verifiedData: null,
  };

  componentWillReceiveProps(nextProps: ElementProps) {
    if (nextProps.mutateResult) {
      const parsedData = JSON.parse(
        nextProps.mutateResult.data.run_third_party_verification.result
      );
      this.setState({
        verified: true,
        modalOpen: true,
        verifiedData: flattenObj(parsedData),
      });
    }
  }

  verify = (): void => {
    const { mutate, queryType, children } = this.props;
    let query = children;

    if (
      queryType === QueryType.ContactToId &&
      query.substr(0, 2).includes("27")
    ) {
      query = children.replace("27", "0");
    }

    mutate({ variables: { query, query_type: queryType } }).catch(
      handleMutationError
    );
  };

  render() {
    const {
      verify,
      state: { modalOpen, verified, verifiedData },
      props: { mutateLoading, children, description },
    } = this;
    return (
      <>
        <VerificationLabel
          onClick={verified ? () => this.setState({ modalOpen: true }) : verify}
          verified={verified}
          loading={mutateLoading}
        >
          {children}
        </VerificationLabel>
        <VerificationDialog
          onRequestClose={() => this.setState({ modalOpen: false })}
          {...{ modalOpen, verifiedData, description }}
        />
      </>
    );
  }
}

export default compose<any>(
  graphql<{}, RecievingProps>(
    gql`
      mutation runThirdPartyVerification(
        $query: String!
        $query_type: ThirdPartyVerificationQueryType!
      ) {
        run_third_party_verification(query: $query, query_type: $query_type) {
          result
        }
      }
    `
  ),
  withStateMutation()
)(VerificationContainer);
